module.exports = __webpack_public_path__ + "img/logo_transparent.43faa05c.png";